"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SttTableBody(props) {
  return /*#__PURE__*/_react["default"].createElement(_TableBody["default"], props);
}
var _default = SttTableBody;
exports["default"] = _default;